// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__AccountSyncPage__ssnLabel{white-space:nowrap}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-quoteandbind-common-react/pages/AccountSync/AccountSyncPage.module.scss"],"names":[],"mappings":"AAAA,gCACI,kBAAA","sourcesContent":[".ssnLabel {\n    white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ssnLabel": "app__AccountSyncPage__ssnLabel"
};
export default ___CSS_LOADER_EXPORT___;
